import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { take } from 'rxjs/operators';
import { CompleteOrderBackendService } from '@complete-order/services/complete-order-backend.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard {
  constructor(
    private readonly router: Router,
    private readonly viewOffersService: ViewOffersService,
    private readonly completeOrderBackendService: CompleteOrderBackendService
  ) {}

  offersState$ = this.viewOffersService.offersState$;

  canActivate(next: ActivatedRouteSnapshot) {
    const paymentAlreadyTaken =
      sessionStorage.getItem(`payment_taken_${next.queryParams?.PRRef}`) ===
      'true';

    if (this.completeOrderBackendService.isProcessingPayment) {
      this.router.navigate(['/', 'processing-order'], {
        queryParamsHandling: 'preserve',
      });
      return;
    }

    if (paymentAlreadyTaken) {
      let pathIncludeConfirmation = false;
      let pathIncludeError = false;

      next.url.forEach((url) => {
        const confirmedPages = ['order-confirmation', 'offer-taken'];
        const errorPages = [
          'offer-not-found',
          'error',
          'offer-error',
          'unauthorised',
        ];

        if (!pathIncludeConfirmation) {
          pathIncludeConfirmation = confirmedPages.includes(url.path);
        }
        if (!pathIncludeError) {
          pathIncludeError = errorPages.includes(url.path);
        }
      });

      if (
        this.completeOrderBackendService.pollingStatus === 'COMPLETE' &&
        !pathIncludeConfirmation
      ) {
        this.router.navigate(['/', 'order-confirmation'], {
          queryParamsHandling: 'preserve',
        });
        return;
      }

      if (
        this.completeOrderBackendService.pollingStatus === 'ERROR' &&
        !pathIncludeError
      ) {
        this.router.navigate(['/', 'offer-error'], {
          queryParamsHandling: 'preserve',
        });
        return;
      }

      return true;
    }

    this.offersState$.pipe(take(1)).subscribe((state) => {
      if (!state.loaded) {
        const PRRef = next.queryParams?.PRRef;
        if (PRRef) {
          this.router.navigate(['/tips'], {
            queryParams: { PRRef },
          });
        } else {
          this.router.navigate(['/offer-not-found'], {
            replaceUrl: true,
          });
        }
      }
    });
    return true;
  }
}
